export const commonUnits = ["sec", "min", "hrs", "days", "USD", "CAD", "EUR", "MXN", "GBP", "atm"];
